import buildConfig from '../build.config.js'
import { pick } from 'lodash';
let brands = {};

buildConfig.cobrandingPartners.forEach((cobrandingPartner, index) => {
    let brandConfig = require('./'+cobrandingPartner+'/config.json');
        brands[brandConfig.dpc] = pick(brandConfig, [
            // add more brand configs if needed in future
            'cobranded',
        ]);
});

export default brands;
